import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export default function ElectricityGenerationMixChart({
  yAxisTitle,
  data,
  colors,
  width,
}) {
  // const max = +Math.max(...data.map((item) => item.value)).toFixed();
  // const min = +Math.min(...data.map((item) => item.value)).toFixed();

  const options = {
    chart: {
      type: "bar",
      spacingBottom: 0,
      spacingTop: 0,
      width: width,
      height: 200,
      backgroundColor: "transparent",
    },

    credits: {
      enabled: false,
    },
    colors: [...colors],
    title: {
      text: undefined,
    },

    tooltip: {
      valueDecimals: 2,
    },
    xAxis: {
      categories: [""],
    },

    yAxis: {
      title: { text: yAxisTitle },
      lineWidth: 2,
      tickLength: 10,
      // tickInterval: 200,
      tickWidth: 1,
      gridLineWidth: 0,
      labels: {
        y: 50,
        formatter: function () {
          return this.value.toString().replace(".", ",");
        },
      },
    },

    legend: {
      reversed: true,
      verticalAlign: "bottom",
      enabled: true,
      align: "center",
      itemMarginBottom: 0,
      symbolPadding: 5,
      navigation: {
        enabled: false,
      },
    },

    plotOptions: {
      bar: { pointWidth: 75, borderWidth: 0, groupPadding: 3 },
      series: {
        stacking: "normal",
      },
    },

    series: data.map((item) => {
      return {
        type: "bar",
        name: item.label,
        data: [item.value],
        decimalPoint: ",",
      };
    }),
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
